import React from "react";
import { Tag, Tooltip } from "src/assets/imports/antdComponents";
import { ILevel2 } from "./interface";
import { useTranslation } from "react-i18next";

interface TagListProps {
	level2Tags: ILevel2[];
	query: string;
	highlightMatch: (text: string, query: string) => JSX.Element;
}

const TagList: React.FC<TagListProps> = ({ level2Tags, query, highlightMatch }) => {
	const { t } = useTranslation();

	// 1. Separate matching vs non-matching tags to prioritize matches in the visible view
	const matchingTags = level2Tags?.filter((tag) => tag.level2Name.toLowerCase().includes(query.toLowerCase())) || [];

	const nonMatchingTags = level2Tags?.filter((tag) => !tag.level2Name.toLowerCase().includes(query.toLowerCase())) || [];

	// 2. Logic to slice tags (show first 2, hide the rest)
	const allSortedTags = [...matchingTags, ...nonMatchingTags];
	const tagsToDisplay = allSortedTags.slice(0, 2);
	const tagsToHide = allSortedTags.slice(2);

	return (
		<>
			{tagsToDisplay.map((tag, index) => (
				<Tag key={`${tag.level2Id}-${index}`} className="study-tag">
					{highlightMatch(tag.level2Name, query)}
				</Tag>
			))}

			{tagsToHide.length > 0 && (
				<Tooltip
					title={
						<div className="tooltip-tags-container">
							{tagsToHide.map((tag, index) => (
								<Tag key={`${tag.level2Id}-${index}`} className="study-tag">
									{highlightMatch(tag.level2Name, query)}
								</Tag>
							))}
						</div>
					}
					placement="top"
					overlayClassName="custom-tooltip">
					<Tag className="study-tag">
						+ {tagsToHide.length} {t("more")}
					</Tag>
				</Tooltip>
			)}
		</>
	);
};

export default TagList;
